import { createFileRoute } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';
import { z } from 'zod';

import { AuthCard } from '@/components/auth/shell/auth-card';
import { AuthSplitShell } from '@/components/auth/shell/auth-split-shell';
import { AuthTopLink } from '@/components/auth/shell/auth-top-link';
import { LoginForm } from '@/components/auth/login/login-form';
import { AuthNotice } from '@/components/auth/shared/auth-notice';
import { SocialSignIn } from '@/components/auth/shared/social-sign-in';
import { ROUTES } from '@/constants/routes';
import { federatedErrorNotice } from '@/lib/social-auth';
import { loadNamespaces } from '@/lib/i18n/i18n';
import { AUTH_HEADLINE } from '@/components/ui/typography';

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  error: z.string().optional(),
});

export const Route = createFileRoute('/_public/login')({
  loader: () => loadNamespaces('auth'),
  validateSearch: loginSearchSchema,
  staticData: { title: 'route.login.title' },
  component: LoginPage,
});

const TopBar = () => {
  const { t } = useTranslation('auth');

  return (
    <>
      <AuthTopLink to={ROUTES.HOME}>{t('shell.back_home')}</AuthTopLink>
      <span>
        <Trans
          i18nKey="login.top_signup"
          ns="auth"
          components={{ a: <AuthTopLink to={ROUTES.SIGNUP} /> }}
        />
      </span>
    </>
  );
};

function LoginPage() {
  const { t } = useTranslation('auth');
  const { redirect, error } = Route.useSearch();

  return (
    <AuthSplitShell topBar={<TopBar />}>
      <h1 className={AUTH_HEADLINE}>{t('login.heading')}</h1>

      <AuthCard>
        <div className="flex flex-col gap-4">
          <AuthNotice tone="error" message={federatedErrorNotice(error)} />
          <SocialSignIn next={redirect} />
          <LoginForm redirect={redirect} />
        </div>
      </AuthCard>
    </AuthSplitShell>
  );
}
